module.exports = __webpack_public_path__ + "img/REG_ALIM_VEGETARIEN.c38db3a7.svg";